export default "/imgs/jrn-1.png"